import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import styles from './GlobalSearchSlideout.module.scss';

interface Team {
  id: string;
  name: string;
}

interface WorkspaceFilterProps {
  teams: Team[];
  selectedTeamIds: string[] | null;
  onWorkspaceChange: (teamIds: string[] | null) => void;
}

export const WorkspaceFilter: React.FC<WorkspaceFilterProps> = ({
  teams,
  selectedTeamIds,
  onWorkspaceChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const sortedTeams = [...teams].sort((a, b) => a.name.localeCompare(b.name));

  const selectedTeam = selectedTeamIds?.length === 1
    ? teams.find((t) => t.id === selectedTeamIds[0])
    : null;

  const label = selectedTeam ? selectedTeam.name : 'In all workspaces';

  // Close dropdown on outside click
  useEffect(() => {
    if (!isOpen) return;

    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [isOpen]);

  return (
    <div className={styles.workspaceFilter} ref={ref}>
      <button
        className={classNames(styles.pill, { [styles.pill__active]: selectedTeamIds !== null })}
        onClick={() => setIsOpen(!isOpen)}
      >
        {label}
        <span style={{ fontSize: '10px', marginLeft: '2px' }}>▾</span>
      </button>

      {isOpen && (
        <div className={styles.workspaceDropdown}>
          <div
            className={classNames(styles.workspaceOption, {
              [styles.workspaceOption__active]: selectedTeamIds === null,
            })}
            onClick={() => {
              onWorkspaceChange(null);
              setIsOpen(false);
            }}
          >
            In all workspaces
          </div>
          {sortedTeams.map((team) => (
            <div
              key={team.id}
              className={classNames(styles.workspaceOption, {
                [styles.workspaceOption__active]: selectedTeamIds?.includes(team.id),
              })}
              onClick={() => {
                onWorkspaceChange([team.id]);
                setIsOpen(false);
              }}
            >
              {team.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
